// Turkish translations
export const tr = {
  // Navigation
  'nav.overview': 'Genel Bakış',
  'nav.dashboard': 'Kontrol Paneli',
  'nav.analytics': 'Analitik',
  'nav.reportingDashboard': 'Raporlama Paneli',
  'nav.sales': 'Satış',
  'nav.salesOrders': 'Satış Siparişleri',
  'nav.purchase': 'Satın Alma',
  'nav.purchaseOrders': 'Satın Alma Siparişleri',
  'nav.purchaseReview': 'İnceleme Çalışma Alanı',
  'nav.purchase.sprints': 'Sprintler',
  'nav.supplierOnboarding': 'Tedarikçi Onboarding',
  'nav.po': 'PO',
  'nav.po.sprints': 'Sprintler',
  'nav.po.newSprint': 'Sprint Oluştur',
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': 'Haftalık Planlama',
  'nav.scout.tagesplanung': 'Günlük Planlama',
  'nav.scout.prequal': 'PreQual Arama',
  'nav.scout.missionen': 'Görevler',
  'nav.scout.missionControl': 'Görev Kontrolü',
  'nav.scout.unternehmenssuche': 'Şirket Arama',
  'nav.scout.preferences': 'Tercihler',
  'nav.scout.hilfe': 'Yardım',
  'nav.scout.scorecard': 'Skor Kartı',
  'nav.poSprints': 'PO/Sprintler',
  'nav.wiki': 'Wiki',
  'nav.supportVisualization': 'Destek Görselleştirme',
  'nav.navigationTiles': 'Navigasyon Kutuları',
  'nav.styleGuide': 'Stil Rehberi',
  'nav.inventory': 'Envanter',
  'nav.items': 'Ürünler',
  'nav.warehouse': 'Depo',
  'nav.picking': 'Toplama',
  'nav.asn': 'ASN',
  'nav.returns': 'İadeler',
  'nav.accounting': 'Muhasebe',
  'nav.accountsReceivable': 'Alacaklar',
  'nav.crm': 'CRM',
  'nav.leads': 'Potansiyel Müşteriler',
  'nav.contacts': 'Kişiler',
  'nav.ai': 'Yapay Zeka',
  'nav.commandCenter': 'Komuta Merkezi',
  'nav.workflows': 'İş Akışları',
  'nav.workflowManagement': 'İş Akışı Yönetimi',
  'nav.projectManagement': 'Proje Yönetimi',
  'nav.support': 'Destek',
  'nav.tickets': 'Biletler',
  'nav.pivotTable': 'Özet Tablo',
  'nav.learning': 'Öğrenme',
  'nav.curriculumPlanning': 'Müfredat Planlama',
  'nav.learnerDashboard': 'Öğrenci Paneli',
  'nav.accessibleLearnerDashboard': 'Erişilebilir Öğrenci Paneli',
  'nav.settings': 'Ayarlar',
  'nav.general': 'Genel',
  'nav.company': 'Şirket',
  'nav.addressManagement': 'Adres Yönetimi',
  'nav.usersRoles': 'Kullanıcılar ve Roller',
  'nav.auditLog': 'Denetim Günlüğü',
  'nav.integrations': 'Entegrasyonlar',
  'nav.appOverview': 'Uygulama Özeti',
  'nav.appOverviewDescription': 'Gezinmek için bir uygulamaya tıklayın veya kutuları yeniden sıralamak için sürükleyin',
  'header.help': 'Yardım',
  'header.account': 'Hesap',
  'header.portalName': 'CLANDA Portal',
  'header.preferences': 'Tercihler',
  'header.language': 'Dil',
  'header.notifications.title': 'Bildirimler',
  'header.notifications.empty': 'Yeni mesaj yok',
  'header.notifications.markAllRead': 'Tümünü okundu işaretle',
  'header.notifications.enablePrompt': 'Anlık bildirimleri etkinleştir?',
  'header.notifications.enableCta': 'Etkinleştir',

  // Help page

  // Privacy page

  // Form

  // Placeholders

  // Status

  // Actions
  'action.delete': 'Sil',

  // Messages
  'message.success': 'Başarılı',
  'message.error': 'Hata',

  // Common
  'common.yes': 'Evet',
  'common.no': 'Hayır',
  'common.cancel': 'İptal',
  'common.confirm': 'Onayla',
  'common.save': 'Kaydet',
  'common.saveChanges': 'Değişiklikleri kaydet',
  'common.close': 'Kapat',
  'common.reset': 'Sıfırla',
  'common.back': 'Geri',
  'common.loading': 'Yükleniyor...',
  'common.search': 'Ara',
  'common.search.placeholder': 'Ara...',
  'common.filter': 'Filtre',
  'common.sort': 'Sırala',
  'common.add': 'Ekle',
  'common.delete': 'Sil',
  'common.edit': 'Düzenle',
  'common.error': 'Hata',
  'common.remove': 'Kaldır',
  'common.minutesShort': '{{value}} dk',
  'common.na': 'Yok',
  'common.days': 'gün',
  'common.status.active': 'aktif',
  'common.status.paused': 'duraklatıldı',
  'common.status.stopped': 'durduruldu',
  'common.status.pending': 'beklemede',
  'common.status.completed': 'tamamlandı',
  'common.status.planned': 'Planlandı',
  'common.status.inProgress': 'Devam Ediyor',
  'common.status.done': 'Tamamlandı',
  'common.apply': 'Uygula',
  'common.actions.filter': 'Filtre',
  'common.actions.export': 'Dışa Aktar',
  'common.actions.search': 'Ara',
  'common.dialog.defaultTitle': 'İletişim',
  'common.all': 'Tümü',
  'common.total': 'Toplam',
  'common.pending': 'Beklemede',
  'common.assigned': 'Atandı',
  'common.inProgress': 'Devam Ediyor',
  'common.completed': 'Tamamlandı',
  'common.cancelled': 'İptal',
  'common.approved': 'Onaylandı',
  'common.rejected': 'Reddedildi',
  'common.processing': 'İşleniyor',
  'common.overdue': 'Gecikmiş',
  'common.partial': 'Kısmi',
  'common.highPriority': 'Yüksek Öncelik',
  'common.tableView': 'Tablo Görünümü',
  'common.cardView': 'Kart Görünümü',
  'common.switchToTable': 'Tablo görünümüne geç',
  'common.switchToCard': 'Kart görünümüne geç',
  'common.openMenu': 'Menüyü aç',
  'common.details': 'Detaylar',
  'common.overview': 'Genel bakış',
  'common.new': 'Yeni',
  'common.draft': 'Taslak',
  'common.shipped': 'Gönderildi',
  'common.delivered': 'Teslim edildi',
  'common.received': 'Alındı',
  'common.inTransit': 'Yolda',
  'common.itemsPicked': 'Toplanan ürünler',
  'common.totalRefund': 'Toplam iade',
  'common.totalPrice': 'Toplam fiyat',
  'common.orderSummary': 'Sipariş Özeti',
  'common.subtotal': 'Ara toplam:',
  'common.tax': 'Vergi:',
  'common.discount': 'İndirim:',
  'common.totalColon': 'Toplam:',

  // Date Range Filter (canonical component)
  'dateRange.today': 'Bugün',
  'dateRange.yesterday': 'Dün',
  'dateRange.last7Days': 'Son 7 gün',
  'dateRange.last14Days': 'Son 14 gün',
  'dateRange.last30Days': 'Son 30 gün',
  'dateRange.thisMonth': 'Bu ay',
  'dateRange.custom': 'Özel',

  // Dashboard
  'widget.vsLastPeriod': 'önceki döneme göre',
  'table.showing': 'Gösterilen',
  'table.of': '/',
  'table.page': 'Sayfa',
  'table.previous': 'Önceki',
  'table.next': 'Sonraki',
  'table.filterGroups': 'Filtre grupları',
  'table.addFilterGroup': 'Filtre grubu ekle',
  'table.filterGroup': 'Filtre grubu',
  'table.addCondition': 'Koşul ekle',
  'table.operator': 'Operatör',
  'table.field': 'Alan',
  'table.noFilterGroups': 'Filtre grubu yok.',
  'filter.operator.equals': 'eşittir',
  'filter.operator.not_equals': 'eşit değildir',
  'filter.operator.contains': 'içerir',
  'filter.operator.not_contains': 'içermez',
  'filter.operator.starts_with': 'ile başlar',
  'filter.operator.ends_with': 'ile biter',
  'filter.operator.gt': 'büyüktür',
  'filter.operator.lt': 'küçüktür',
  'filter.operator.gte': 'en az',
  'filter.operator.lte': 'en çok',
  'filter.operator.between': 'arasında',
  'filter.operator.in': 'birisidir',
  'filter.operator.not_in': 'birisi değildir',
  'filter.operator.is_set': 'tanımlı',
  'filter.operator.is_not_set': 'tanımsız',
  'filter.placeholder.value': 'Değer',
  'filter.placeholder.min': 'Min',
  'filter.placeholder.max': 'Maks',
  'filter.placeholder.select': 'Seçin…',
  'filter.placeholder.selectMultiple': 'Değer seçin…',
  'filter.logic.and': 'VE',
  'filter.logic.or': 'VEYA',

  // Documents

  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': 'Hesap Ayarları',

  // Consent
  'consent.title': 'Onay',
  'consent.label': 'Şartları ve sipariş politikasını kabul ediyorum',
  'consent.description': 'Şartları okudum ve kabul ediyorum.',
  'consent.required': 'Lütfen şartları kabul edin.',
  'consent.link.terms': 'Şartlar',

  // Contacts
  'contacts.title': 'Kişiler',
  'contacts.role': 'Rol',
  'contacts.role.admin': 'Yönetici',
  'contacts.role.billing': 'Faturalandırma',
  'contacts.role.technical': 'Teknik',
  'contacts.role.other': 'Diğer',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': 'Kimlik Doğrulama',

  // Debug

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page

  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Learning & Development
  'learning.feed.greeting': 'Merhaba {{name}}!',
  'learning.feed.levelInfo': 'Seviye {{level}} • {{xp}} XP',
  'learning.feed.offline': 'Çevrimdışı',
  'learning.feed.streakLabel': 'Gün serisi',
  'learning.feed.dailyGoal': 'Günlük hedef',
  'learning.feed.recommendedLessons': 'Önerilen dersler',
  'learning.feed.priority.high': 'Yüksek',
  'learning.feed.priority.medium': 'Orta',
  'learning.feed.priority.low': 'Düşük',
  'learning.feed.difficulty.easy': 'Kolay',
  'learning.feed.difficulty.medium': 'Orta',
  'learning.feed.difficulty.hard': 'Zor',
  'learning.feed.aiRecommendation': 'Yapay zeka önerisi',
  'learning.feed.actions.start': 'Başla',
  'learning.feed.actions.skip': 'Atla',
  'learning.feed.actions.reload': 'Yenile',
  'learning.feed.empty.title': 'Tüm dersler tamamlandı!',

  // Helpdesk / Tickets
  'learning.feed.empty.description': 'Bugün için tüm mevcut dersleri tamamladınız. Yarın tekrar gelin!',
  'learning.quiz.title': 'Quiz',
  'learning.quiz.questionCounter': 'Soru {{current}} / {{total}}',
  'learning.quiz.options.true': 'Doğru',
  'learning.quiz.options.false': 'Yanlış',
  'learning.quiz.actions.next': 'İleri',
  'learning.quiz.actions.finish': 'Bitir',
  'learning.quiz.actions.retry': 'Tekrar dene',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}s',
  'learning.quiz.result.passedTitle': 'Quiz geçildi!',
  'learning.quiz.result.failedTitle': 'Quiz geçilemedi',
  'learning.quiz.result.scoreSummary': '{{correct}} / {{total}} doğru',
  'learning.quiz.result.xpEarned': '+{{xp}} XP kazanıldı',
  'learning.quiz.result.answersHeading': 'Yanıtlar detayı',
  'learning.quiz.result.questionLabel': 'Soru {{index}}',
  'learning.quiz.result.yourAnswer': 'Sizin yanıtınız',
  'learning.quiz.result.correctAnswer': 'Doğru yanıt',
  'learning.lessonCard.difficulty.easy': 'Kolay',
  'learning.lessonCard.difficulty.medium': 'Orta',
  'learning.lessonCard.difficulty.hard': 'Zor',
  'learning.lessonCard.status.completed': 'Tamamlandı',
  'learning.lessonCard.reward': 'Ödül',
  'learning.lessonCard.progress': 'İlerleme',
  'learning.lessonCard.selectFormat': 'Format seçin',
  'learning.lessonCard.prerequisites': 'Ön koşullar',
  'learning.lessonCard.actions.start': 'Başla',
  'learning.lessonCard.actions.repeat': 'Tekrarla',
  'learning.lessonCard.actions.pause': 'Duraklat',
  'learning.lessonCard.actions.complete': 'Tamamla',
  'learning.lessonCard.actions.bookmark': 'Yer imi ekle',
  'learning.lessonCard.actions.unbookmark': 'Yer imini kaldır',
  'learning.lessonCard.actions.collapse': 'Daralt',
  'learning.lessonCard.actions.expand': 'Genişlet',
  'learning.lessonCard.goalLabel': 'Hedef',
  'learning.lessonCard.formats.video': 'Video izle',
  'learning.lessonCard.formats.text': 'Metin oku',
  'learning.lessonCard.formats.audio': 'Ses dinle',
  'learning.lessonCard.formats.cheatSheet': 'Kopya kağıdı',
  'learning.lessonCard.formatUnknown': 'Bilinmiyor',
  'learning.accessible.title': 'Öğrenme Paneli',
  'learning.accessible.welcome': 'Tekrar hoş geldin, {{name}}',
  'learning.accessible.voice.start': 'Ses',
  'learning.accessible.voice.stop': 'Ses kontrolünü sonlandır',
  'learning.accessible.voice.listening': 'Dinleniyor...',
  'learning.accessible.level': 'Seviye',
  'learning.accessible.xpToNext': 'Sonraki seviyeye {{value}} XP',
  'learning.accessible.streak': 'Seri',
  'learning.accessible.days': '{{value}} gün',
  'learning.accessible.keepItUp': 'Böyle devam et!',
  'learning.accessible.badges': 'Rozetler',
  'learning.accessible.achievementsEarned': 'Başarılar',
  'learning.accessible.tabs.overview': 'Genel bakış',
  'learning.accessible.tabs.lessons': 'Dersler',
  'learning.accessible.tabs.progress': 'İlerleme',
  'learning.accessible.tabs.achievements': 'Başarılar',
  'learning.accessible.recentActivity': 'Son aktiviteler',
  'learning.accessible.noRecentActivity': 'Aktivite yok',
  'learning.accessible.start': 'Başla',
  'learning.accessible.learningProgress': 'Öğrenme ilerlemesi',
  'learning.accessible.overallProgress': 'Genel ilerleme',
  'learning.accessible.achievements': 'Başarılar',
  'learning.accessible.startingLesson': '{{id}} dersi başlatılıyor',
  'learning.accessible.difficulty.beginner': 'Başlangıç',
  'learning.accessible.difficulty.intermediate': 'Orta',
  'learning.accessible.difficulty.advanced': 'İleri',

  // Gamification & XP Toast
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': 'Seri ilerlemesi',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'Ders',
  'gamification.xpToast.source.quiz': 'Quiz',
  'gamification.xpToast.source.streak': 'Seri',
  'gamification.xpToast.source.badge': 'Rozet',
  'gamification.xpToast.source.bonus': 'Bonus',
  'gamification.xpToast.levelUp.title': 'Seviye atladınız!',
  'gamification.xpToast.levelUp.description': '{{level}}. seviyeye ulaştınız!',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP kazanıldı',
  'gamification.xpToast.button.continue': 'Devam',
  'gamification.xpToast.streakMilestone.title': 'Seri kilometre taşı!',
  'gamification.xpToast.streakMilestone.description': '{{count}} günlük seriye ulaşıldı!',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP bonusu kazanıldı',
  'gamification.close': 'Kapat',

  // Wissensdatenbank
  'knowledgeBase.back': 'Geri',
  'knowledgeBase.article.view': 'Görüntüle',
  'knowledgeBase.article.views': '{{count}} görüntülenme',
  'knowledgeBase.article.helpful': '{{count}} faydalı',
  'knowledgeBase.article.notHelpful': '{{count}} faydalı değil',
  'knowledgeBase.article.byAuthor': '{{author}} tarafından',
  'knowledgeBase.header.title': 'Bilgi bankası',
  'knowledgeBase.header.subtitle': 'Sorularınızın yanıtlarını bulun',
  'knowledgeBase.actions.filter': 'Filtre',
  'knowledgeBase.actions.sort': 'Sırala',
  'knowledgeBase.search.placeholder': 'Bilgi bankasında ara...',
  'knowledgeBase.tabs.all': 'Tümü',
  'knowledgeBase.stats.popular': 'En popüler makaleler',
  'knowledgeBase.stats.viewsCount': '{{count}} görüntülenme',
  'knowledgeBase.stats.helpful': 'En faydalı makaleler',
  'knowledgeBase.stats.ratingsCount': '{{count}} değerlendirme',
  'knowledgeBase.stats.total': 'Toplam makale',
  'knowledgeBase.stats.totalCount': '{{count}} makale',
  'knowledgeBase.empty.title': 'Makale bulunamadı',
  'knowledgeBase.empty.searching': 'Farklı arama terimleri deneyin veya kategorilere bakın.',
  'knowledgeBase.empty.default': 'Bu kategoride henüz makale yok.',
  'knowledgeBase.difficulty.beginner': 'Başlangıç',
  'knowledgeBase.difficulty.intermediate': 'İleri',
  'knowledgeBase.difficulty.advanced': 'Uzman',
  'knowledgeBase.categories.odoo-basics': 'Odoo temelleri',
  'knowledgeBase.categories.crm': 'CRM ve satış',
  'knowledgeBase.categories.inventory': 'Depo ve satın alma',
  'knowledgeBase.categories.accounting': 'Muhasebe',
  'knowledgeBase.categories.projects': 'Proje yönetimi',
  'knowledgeBase.categories.troubleshooting': 'Sorun giderme',

  // Accounting

  // Curriculum Planning
  'curriculum.video': 'Video',
  'curriculum.videoDescription': 'Ekran kaydı veya uygulama videosu',
  'curriculum.cheatSheet': 'Kopya kağıdı',
  'curriculum.cheatSheetDescription': 'Yazdırılabilir, QR kodlu',
  'curriculum.test': 'Test/Quiz',
  'curriculum.testDescription': 'Odoo anketi, 10 soru, %80',
  'curriculum.checklist': 'Kontrol listesi',
  'curriculum.checklistDescription': 'Odoo görevleri, tıklanabilir',
  'curriculum.textLesson': 'Metin/Ders',
  'curriculum.textLessonDescription': 'Odoo kurs dersi',
  'curriculum.roleplay': 'Rol oyunu',
  'curriculum.roleplayDescription': 'Canlı mentor ile',
  'curriculum.practice': 'Uygulama görevi',
  'curriculum.practiceDescription': 'Müşteride uygulayın',

  // UI Components

  // Purchase Onboarding (wizard)

  // SCOUT - Wochenplanung
  'scout.wochenplanung.title': 'Haftalık özet',
  'scout.wochenplanung.previousWeek': 'Önceki hafta',
  'scout.wochenplanung.nextWeek': 'Sonraki hafta',
  'scout.wochenplanung.toast.appointmentAdded': 'Randevu eklendi',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': 'Randevu güncellendi',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': 'Randevu silindi',
  'scout.wochenplanung.toast.slotUpdated': 'Slot güncellendi',
  'scout.wochenplanung.toast.slotUpdatedDesc': 'Görev çözüldü veya slot kaldırıldı.',
  'scout.wochenplanung.legend.completed': 'tamamlandı',
  'scout.wochenplanung.legend.planned': 'planlandı',
  'scout.wochenplanung.legend.partial': 'kısmen planlandı',
  'scout.wochenplanung.legend.unplanned': 'planlanacak',
  'scout.wochenplanung.legend.holiday': 'Tatil / İzin',
  'scout.wochenplanung.dialog.deleteAppointment.title': 'Randevuyu sil',
  'scout.wochenplanung.dialog.deleteAppointment.description': 'Bu randevuyu silmek istediğinize emin misiniz? Bu işlem geri alınamaz.',
  'scout.wochenplanung.dialog.editAppointment.title': 'Randevuyu düzenle',
  'scout.wochenplanung.dialog.editAppointment.description': 'Bu randevudaki değişiklikleri uygulamak istiyor musunuz?',
  'scout.wochenplanung.employee': 'Çalışan',
  'scout.wochenplanung.selectEmployee': 'Çalışan seçin',
  'scout.wochenplanung.allEmployees': 'Tüm çalışanlar',
  'scout.wochenplanung.error.loading': 'Haftalık planlama yüklenirken hata',
  'scout.wochenplanung.error.retry': 'Tekrar dene',

  // SCOUT - Mission list empty state & actions
  'scout.missionControl.tabs.team': 'Takım özeti',
  'scout.missionControl.teamMembers': 'Takım üyeleri',
  'scout.missionControl.table.employee': 'Çalışan',
  'scout.missionControl.table.team': 'Takım',
  'scout.missionControl.table.plzAreas': 'Posta kodu alanları',

  // SCOUT - Mission Preferences

  // SCOUT - Missionen
  'scout.missionen.bestandskunden.loadError': 'Mevcut müşteriler yüklenirken hata',
  'scout.missionen.bestandskunden.empty': 'Mevcut müşteri bulunamadı',
  'scout.missionen.bestandskunden.search': 'Mevcut müşterileri ara...',
  'scout.missionen.bestandskunden.filteredCount': '{{total}} mevcut müşteriden {{filtered}} tanesi',
  'scout.missionen.wunschliste.industriesTitle': 'Tercih edilen sektörler',
  'scout.missionen.wunschliste.productsTitle': 'Tercih edilen ürünler',
  'scout.missionen.wunschliste.plzTitle': 'Tercih edilen posta kodu bölgeleri',
  'scout.missionen.wunschliste.saveButton': 'Kaydet',
  'scout.missionen.wunschliste.saved': 'Kaydedildi',
  'scout.missionen.wunschliste.savedDesc': 'Tercihleriniz kaydedildi.',
  'scout.missionen.wunschliste.saveError': 'Hata',
  'scout.missionen.wunschliste.saveErrorDesc': 'Tercihler kaydedilemedi.',
  'scout.missionen.wunschliste.loadError': 'Tercihler yüklenirken hata',
  'scout.tagesplanung.title': 'Günlük planlama',
  'scout.tagesplanung.addressUnknown': 'Adres bilinmiyor',
  'scout.tagesplanung.routeMapLabel': 'Rota haritası',
  'scout.tagesplanung.routePlanning': 'Rota planlama',
  'scout.tagesplanung.traffic': 'Trafik',
  'scout.tagesplanung.deferNotPossible': 'Ertelemek mümkün değil',
  'scout.tagesplanung.deferMaxReached': 'Bugün için maksimum erteleme sayısına ulaşıldı (3/3).',
  'scout.tagesplanung.deferAlreadyDeferred': 'Bu potansiyel müşteri bugün zaten ertelendi.',
  'scout.tagesplanung.dayCannotClose': 'Gün kapatılamaz',
  'scout.tagesplanung.outstandingReports': '{{count}} bekleyen ziyaret raporu var. Günü kapatmadan önce hepsini doldurun.',
  'scout.tagesplanung.andMore': '... ve {{count}} tane daha',
  'scout.tagesplanung.tabs.planning': 'Günlük plan',
  'scout.tagesplanung.tasks.tabLabel': 'Görevler',
  'scout.tagesplanung.tasks.empty': 'Görev yok',
  'scout.tagesplanung.tasks.loading': 'Görevler yükleniyor',
  'scout.tagesplanung.tasks.error': 'Görevler yüklenemedi',
  'scout.tagesplanung.tasks.filterFieldStatus': 'Durum',
  'scout.tagesplanung.tasks.filterStatusTodo': 'Yapılacak',
  'scout.tagesplanung.tasks.filterStatusInProgress': 'Devam ediyor',
  'scout.tagesplanung.tasks.filterStatusDone': 'Tamamlandı',
  'scout.tagesplanung.tasks.priorityLabel': 'Öncelik',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': 'Bitiş',
  'scout.tagesplanung.tasks.dueNone': 'Bitiş tarihi yok',
  'scout.lead.neukunde': 'Yeni müşteri — niş ürün giriş aracı',
  'scout.lead.bestandskunde': 'Mevcut müşteri',
  'scout.metrics.besuche': 'Ziyaretler',
  'scout.metrics.demos': 'Demolar',
  'scout.metrics.auftraege': 'Siparişler',
  'scout.metrics.umsatz': 'Gelir',
  'scout.metrics.demoRate': 'Demo oranı',
  'scout.composition.title': 'Görev bileşimi',
  'scout.composition.minBestandskunden': 'Min. mevcut müşteri',
  'scout.composition.minQualifiziert': 'Min. nitelikli potansiyel müşteri',
  'scout.composition.maxKaltbesuche': 'Max. soğuk ziyaret',

  // Scout daily planning
  'scout.dailyPlanning.addAppointment': 'Randevu ekle',
  'scout.dailyPlanning.appointments': 'Randevular',
  'scout.dailyPlanning.noAppointmentsPlanned': 'Bu gün için randevu planlanmadı',
  'scout.dailyPlanning.leadsByPriority': 'Potansiyel müşteriler (önceliğe göre)',
  'scout.dailyPlanning.noLeadsPlanned': 'Bu gün için potansiyel müşteri planlanmadı',
  'scout.dailyPlanning.skipLead': 'Potansiyel müşteriyi atla',
  'scout.dailyPlanning.skipLeadConfirmation': 'Bu potansiyel müşteriyi gerçekten atlamak istiyor musunuz? Bir sonraki güne taşınacak.',
  'scout.dailyPlanning.skip': 'Atla',
  'scout.dailyPlanning.removeLead': 'Potansiyel müşteriyi kaldır',
  'scout.dailyPlanning.removeLeadConfirmation': 'Bu potansiyel müşteriyi gerçekten kaldırmak istiyor musunuz? Rotasyondan tamamen çıkarılacak.',
  'scout.dailyPlanning.selectMissionToViewLeads': 'Potansiyel müşterileri görmek için bir görev seçin',
  'scout.dailyPlanning.selectDate': 'Tarih seçin',
  'scout.dailyPlanning.nextDay': 'Sonraki gün',
  'scout.dailyPlanning.closeDay': 'Günü kapat',
  'scout.dailyPlanning.reopenDay': 'Günü yeniden aç',
  'scout.dailyPlanning.noAcceptedLeads': 'Bu gün için kabul edilen potansiyel müşteri yok.',
  'scout.dailyPlanning.statusSkipped': 'Atlandı',
  'scout.dailyPlanning.selectAll': 'Tümünü seç',
  'scout.dailyPlanning.selectAllLeads': 'Tüm potansiyel müşterileri seç',
  'scout.dailyPlanning.noSuggestions': 'Öneri yok.',
  'scout.dailyPlanning.previousDay': 'Önceki gün',
  'scout.dailyPlanning.calendarWeek': 'Takvim haftası {{weekNumber}}',
  'scout.dailyPlanning.visit': 'Ziyaret',
  'scout.dailyPlanning.details': 'Detaylar',
  'scout.dailyPlanning.missionsLoading': 'Görevler yükleniyor…',
  'scout.dailyPlanning.leadsLoading': 'Potansiyel müşteriler yükleniyor…',
  'scout.dailyPlanning.noLeadsFound': 'Potansiyel müşteri bulunamadı',
  'scout.dailyPlanning.moreLeads': 'daha fazla',
  'scout.dailyPlanning.dailyList': 'Günlük liste',
  'scout.dailyPlanning.unknown': 'Bilinmiyor',
  'scout.dailyPlanning.suggestedLeads': 'Önerilen potansiyel müşteriler',
  'scout.dailyPlanning.error': 'Hata: {{error}}',
  'scout.dailyPlanning.help': 'Yardım',
  'scout.dailyPlanning.bulkActions': 'Toplu işlemler',
  'scout.dailyPlanning.actionsCount': 'İşlemler ({{count}})',
  'scout.dailyPlanning.accept': 'Kabul et',
  'scout.dailyPlanning.reject': 'Reddet',
  'scout.dailyPlanning.selectLead': '{{name}} potansiyel müşterisini seç',
  'scout.dailyPlanning.openLeadDetails': '{{name}} detaylarını aç',
  'scout.dailyPlanning.score': 'Puan: {{score}}',
  'scout.dailyPlanning.loading': 'Günlük planlama yükleniyor',

  // Scout scorecard
  'scout.scorecard.selectHeatmapMetric': 'Isı haritası metriği seçin',
  'scout.scorecard.orders': 'Siparişler',
  'scout.scorecard.annualTargetOrders': 'Yıllık sipariş hedefi',
  'scout.scorecard.comingSoon': 'Yakında',
  'scout.scorecard.kpiOverview': 'KPI özeti, aktiviteler ve en iyi sektörler',
  'scout.scorecard.activityByDay': 'Güne göre aktivite',
  'scout.scorecard.title': 'Skor kartı',
  'scout.scorecard.period.tag': 'Gün',
  'scout.scorecard.period.woche': 'Hafta',
  'scout.scorecard.period.monat': 'Ay',
  'scout.scorecard.period.jahr': 'Yıl',
  'scout.scorecard.kpiTilesHeading': 'KPI kutuları',
  'scout.scorecard.topBranchenProdukteHeading': 'En iyi sektörler ve ürünler',
  'scout.scorecard.soll': 'Hedef',
  'scout.scorecard.forecast': 'Tahmin',
  'scout.scorecard.gapToGo': 'Kalan açık',
  'scout.scorecard.csvExport': 'CSV dışa aktar',
  'scout.scorecard.pdfExport': 'PDF dışa aktar',
  'scout.scorecard.table.date': 'Tarih',
  'scout.scorecard.table.visits': 'Ziyaretler',
  'scout.scorecard.table.demos': 'Demolar',
  'scout.scorecard.table.orders': 'Siparişler',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': 'Net gelir',
  'scout.scorecard.table.total': 'Toplam',
  'scout.scorecard.topBranchen': 'En iyi sektörler',
  'scout.scorecard.topProdukte': 'En iyi ürünler',
  'scout.scorecard.table.industry': 'Sektör',
  'scout.scorecard.table.quantity': 'Miktar (birim)',
  'scout.scorecard.table.revenue': 'Gelir (€)',
  'scout.scorecard.table.product': 'Ürün',
  'scout.scorecard.table.salesVolume': 'Satış hacmi',
  'scout.scorecard.table.customers': 'Müşteriler',
  'scout.scorecard.kpi.visits': 'Ziyaretler',
  'scout.scorecard.kpi.demos': 'Demolar',
  'scout.scorecard.kpi.orders': 'Siparişler',
  'scout.scorecard.kpi.netRevenue': 'Net gelir',
  'scout.scorecard.kpi.gebinde60l': '60L birim',
  'scout.scorecard.kpi.gebinde25l': '25L birim',
  'scout.scorecard.kpi.gebinde10l': '10L birim',
  'scout.scorecard.emptyTitle': 'Veri yok',
  'scout.scorecard.emptyDescription': 'Seçilen dönem için KPI verisi yok.',
  'scout.scorecard.missionPerformanceTitle': 'Görev performansı',
  'scout.scorecard.missionMissionsCompleted': 'Tamamlanan görevler',
  'scout.scorecard.missionConversionRate': 'Dönüşüm oranı',
  'scout.scorecard.missionTerritoryCoverage': 'Bölge kapsamı',
  'scout.scorecard.viewMissionDetails': 'Detayları göster',
  'scout.scorecard.adjustTargets': 'Hedefleri ayarla',
  'scout.scorecard.annualTarget': 'Yıllık hedef',
  'scout.scorecard.annualTargetVisits': 'Yıllık ziyaret hedefi',
  'scout.scorecard.annualTargetDemos': 'Yıllık demo hedefi',
  'scout.scorecard.annualTargetNetRevenue': 'Net gelir (€)',
  'scout.scorecard.annualTargetNetRevenueA11y': 'Yıllık net gelir hedefi (Euro)',
  'scout.scorecard.monthlyOverrides': 'Aylık sapmalar',
  'scout.scorecard.table.month': 'Ay',
  'scout.scorecard.table.reason': 'Gerekçe',
  'scout.scorecard.derivedTargets': 'Türetilmiş hedefler',
  'scout.scorecard.dailyTargetLabel': 'Günlük hedef: {{count}} ziyaret',
  'scout.scorecard.weeklyTargetLabel': 'Haftalık hedef: {{count}} ziyaret',
  'scout.scorecard.save': 'Kaydet',
  'scout.scorecard.heatmap.visits': 'Ziyaretler',
  'scout.scorecard.heatmap.demos': 'Demolar',
  'scout.scorecard.heatmap.revenue': 'Gelir',
  'scout.scorecard.heatmap.low': 'Düşük',
  'scout.scorecard.heatmap.high': 'Yüksek',
  'scout.scorecard.heatmap.scaleA11y': 'Düşükten yükseğe renk ölçeği',
  'scout.scorecard.heatmap.loading': 'Harita yükleniyor…',

  // Scout mission control
  'scout.missionControl.teamOverview': 'Takımınız ve posta kodu bölgeleri',
  'scout.missionControl.jokerLimitPerDay': 'Joker limiti / gün',
  'scout.missionControl.jokerLimitUpdated': 'Joker limiti güncellendi.',
  'scout.missionControl.jokerLimitSaveFailed': 'Joker limiti kaydedilemedi.',
  'scout.missionControl.selectTeam': 'Takım seçin',
  'scout.missionControl.none': 'Yok',
  'scout.missionControl.addPlzAreaFor': 'Posta kodu bölgesi ekle:',
  'scout.missionControl.addPlzArea': 'Posta kodu bölgesi ekle',
  'scout.missionControl.noTeamMembersFound': 'Takım üyesi bulunamadı.',
  'scout.missionControl.orders': 'Siparişler',
  'scout.missionControl.resetSettings': 'Ayarları sıfırla',
  'scout.missionControl.saveSettings': 'Ayarları kaydet',
  'scout.missionControl.territorySaturation': 'Bölge doygunluğu (posta kodu)',
  'scout.missionControl.day': 'Gün',
  'scout.missionControl.selectDay': 'Gün seçin',
  'scout.missionControl.week': 'Hafta',
  'scout.missionControl.selectWeek': 'Hafta seçin',
  'scout.missionControl.month': 'Ay',
  'scout.missionControl.selectMonth': 'Ay seçin',
  'scout.missionControl.planFulfillment': 'Plan gerçekleşme',
  'scout.missionControl.plzPrefixPlaceholder': 'Posta kodu öneki (örn. 70)',
  'scout.missionControl.plzPrefix': 'Posta kodu öneki',
  'scout.missionControl.addPlzToWhitelist': 'Posta kodu önekini beyaz listeye ekle',
  'scout.missionControl.addPlzToGreylist': 'Posta kodu önekini gri listeye ekle',
  'scout.missionControl.addPlzToYellowlist': 'Posta kodu önekini sarı listeye ekle',
  'scout.missionControl.addNewTeamMember': 'Yeni takım üyesi ekle',
  'scout.missionControl.lastModified': 'Son değişiklik',
  'scout.missionControl.outsideAreaRules': 'Bölge dışı kuralları',
  'scout.missionControl.outsidePlzPolicy': 'Listeler dışındaki posta kodları politikası',
  'scout.missionControl.enableOutsideWarning': 'Bölge dışı posta kodu uyarısını etkinleştir',
  'scout.missionControl.requireOutsideApproval': 'Bölge dışı posta kodu onayı gerekli',
  'scout.missionControl.rejectOutsidePlz': 'Bölge dışı posta kodunu reddet',
  'scout.missionControl.checkPlz': 'Posta kodu veya önek kontrol et',
  'scout.missionControl.check': 'Kontrol et',
  'scout.missionControl.error': 'Hata',
  'scout.missionControl.success': 'Başarılı',
  'scout.missionControl.userProfileNotFound': 'Kullanıcı profili bulunamadı',
  'scout.missionControl.plzAreasUpdated': 'Posta kodu bölgeleri güncellendi',
  'scout.missionControl.plzAreasSaveFailed': 'Posta kodu bölgeleri kaydedilemedi',

  // Mission Control → Config → KPI Target Configuration

  // Scout Mission Control — Rep Config
  'scout.missionControl.repConfig.title': 'Temsilci yapılandırması',
  'scout.missionControl.repConfig.repName': 'Ad / E-posta',
  'scout.missionControl.repConfig.industries': 'Sektörler',
  'scout.missionControl.repConfig.products': 'Ürünler',
  'scout.missionControl.repConfig.plz': 'Posta kodu',
  'scout.missionControl.repConfig.loadError': 'Temsilci yapılandırması yüklenemedi',
  'scout.missionControl.repConfig.saveError': 'Kaydetme başarısız',
  'scout.missionControl.repConfig.savedTitle': 'Kaydedildi',
  'scout.missionControl.repConfig.savedDesc': 'Temsilci yapılandırması güncellendi',

  // Scout Mission Control — Joker Limit
  'scout.missionControl.jokerConfig.title': 'Günlük joker limiti',
  'scout.missionControl.jokerConfig.description': 'Temsilci ve gün başına maksimum joker kullanımı.',
  'scout.missionControl.jokerConfig.maxPerDay': 'Günlük max.',
  'scout.missionControl.jokerConfig.loadError': 'Joker yapılandırması yüklenemedi',
  'scout.missionControl.jokerConfig.saveError': 'Kaydetme başarısız',
  'scout.missionControl.jokerConfig.savedTitle': 'Kaydedildi',
  'scout.missionControl.jokerConfig.savedDesc': 'Joker limiti güncellendi',

  // Scout session

  // Scout Mission Control — territories

  // Scout Mission Control — diagnostics
  'scout.missionControl.diagnostics.demoRate': 'Demo oranı',
  'scout.missionControl.diagnostics.visitDepth': 'Ziyaret derinliği',

  // Scout Unternehmenssuche
  'scout.unternehmenssuche.selectAllResults': 'Tüm arama sonuçlarını seç',
  'scout.unternehmenssuche.openingHours': 'ÇALIŞMA SAATLERİ',
  'scout.unternehmenssuche.temporarilyClosed': 'Geçici olarak kapalı',
  'scout.unternehmenssuche.startSearch': 'Aramayı başlat',
  'scout.unternehmenssuche.searchRunning': 'Arama çalışıyor...',
  'scout.unternehmenssuche.adjustSearchCriteria': 'Lütfen arama kriterlerini değiştirin veya tekrar deneyin.',
  'scout.unternehmenssuche.selectCompanyType': 'Şirket türü seçin',
  'scout.unternehmenssuche.openingHoursTime': 'Çalışma saati',
  'scout.unternehmenssuche.noTimeNeeded': 'Saat gerekmez',
  'scout.unternehmenssuche.addConditions': 'Aramayı daraltmak için koşul ekleyin',
  'scout.unternehmenssuche.addCondition': 'Koşul ekle',
  'scout.unternehmenssuche.addGroup': 'Grup ekle',
  'scout.unternehmenssuche.savedSearchName': 'Kayıtlı arama adı',
  'scout.unternehmenssuche.saveCurrentSearch': 'Mevcut aramayı kaydet',
  'scout.unternehmenssuche.savedSearches': 'Kayıtlı aramalar',
  'scout.unternehmenssuche.noSavedSearches': 'Kayıtlı arama yok.',
  'scout.unternehmenssuche.keywordPlaceholder': 'örn. Restoran, Bar, Fırın',
  'scout.unternehmenssuche.addWaypoint': 'Ara durak ekle',
  'scout.unternehmenssuche.locationPlaceholder': 'örn. İstanbul Taksim',
  'scout.unternehmenssuche.toggleAdditionalFilters': 'Ek filtreleri aç/kapat',
  'scout.unternehmenssuche.additionalFilters': 'Ek filtreler',
  'scout.unternehmenssuche.saveSearchAsFile': 'Aramayı dosya olarak kaydet',
  'scout.unternehmenssuche.loadSearchFromFile': 'Dosyadan arama yükle',
  'scout.unternehmenssuche.checkSearchTerms': 'Lütfen arama terimlerinizi kontrol edin veya tekrar deneyin.',

  // Search overlay
  'search.overlay.hint': 'Yazıp Enter\'a basın veya Ara\'ya tıklayın.',
  'search.overlay.placeholder': 'Kaynak, doküman ve daha fazlası için ara (/)',
  'search.overlay.searchLabel': 'Ara',
  'search.overlay.noResults': '„{{query}}" için sonuç yok',
  'search.overlay.tryDifferent': 'Farklı terimler deneyin veya yazımı kontrol edin.',
  'search.overlay.topResults': 'En iyi sonuçlar',
  'search.overlay.documentation': 'Dokümantasyon · ',

  // Location/Route toggle
  'scout.unternehmenssuche.locationRadius': 'Konum + yarıçap',
  'scout.unternehmenssuche.routeCorridor': 'Rota + koridor',
  'scout.unternehmenssuche.withoutLocation': 'Konumsuz',

  // Scout missions (Wave 3 i18n)
  'scout.scorecard.heatmapTitle': 'Aktivite ısı haritası (posta kodu-2)',
  'scout.preferences.defaultRegionLabel': 'Varsayılan bölge',
  'scout.preferences.selectRegionPlaceholder': 'Bölge seçin',
  'scout.preferences.defaultStatusLabel': 'Varsayılan durum',
  'scout.preferences.selectDefaultStatus': 'Varsayılan durum seçin',
  'scout.preferences.statusDraft': 'Taslak',
  'scout.preferences.statusActive': 'Aktif',
  'scout.preferences.statusCompleted': 'Tamamlandı',
  'scout.preferences.statusArchived': 'Arşivlendi',
  'scout.preferences.saving': 'Kaydediliyor...',
  'scout.preferences.plzPrefixes': 'Görevler için posta kodu önekleri',
  'scout.preferences.plzPrefixesPlaceholder': 'Virgülle ayrılmış posta kodu önekleri girin (örn. 34, 35, 36)',
  'scout.preferences.maxRouteLength': 'Maks. rota uzunluğu (km)',
  'scout.preferences.maxRouteLengthDescription': 'Kilometre cinsinden maksimum rota uzunluğu',
  'scout.preferences.autoGenerateMissions': 'Görevleri otomatik oluştur (gece otomasyonu)',
  'scout.preferences.autoGenerateDescription': 'Etkinleştirildiğinde, ayarlarınıza göre görevler otomatik oluşturulur.',
  'scout.preferences.defaultAssigneeLabel': 'Varsayılan sorumlu',
  'scout.preferences.defaultAssigneePlaceholder': 'Varsayılan sorumlu girin',
  'scout.preferences.defaultAssigneeAria': 'Varsayılan sorumlu',
  'scout.preferences.defaultLeadCountLabel': 'Varsayılan potansiyel müşteri sayısı',
  'scout.preferences.defaultLeadCountAria': 'Varsayılan potansiyel müşteri sayısı',
  'scout.preferences.defaultDurationLabel': 'Varsayılan süre (gün)',
  'scout.preferences.defaultDurationAria': 'Gün cinsinden varsayılan süre',
  'scout.preferences.autoAssignLabel': 'Görevleri varsayılan sorumluya otomatik ata',
  'scout.preferences.productFamiliesLabel': 'Ürün aileleri',
  'scout.preferences.industryCodesLabel': 'Sektörler',
  'scout.preferences.keywordsLabel': 'Anahtar kelimeler',
  'scout.preferences.keywordsPlaceholder': 'örn. beton, şap',
  'scout.preferences.minLeadsLabel': 'Görev başına min. potansiyel müşteri',
  'scout.preferences.minLeadsAria': 'Görev başına minimum potansiyel müşteri',
  'scout.preferences.maxLeadsLabel': 'Görev başına max. potansiyel müşteri',
  'scout.preferences.maxLeadsAria': 'Görev başına maksimum potansiyel müşteri',
  'scout.preferences.dailyQuotaLabel': 'Günlük görev sayısı',
  'scout.preferences.dailyQuotaAria': 'Günlük maksimum görev',
  'scout.preferences.dailyQuotaHelper': 'Günlük otomatik oluşturulan maksimum görev (1-3)',
  'scout.dailyPlanning.inField': 'Sahada',
  'scout.dailyPlanning.completed': 'Tamamlandı',
  'scout.dailyPlanning.openDay': 'Günü aç',
  'scout.dailyPlanning.dayMarkedCompleted': 'Bu gün tamamlandı olarak işaretlendi.',
  'scout.dailyPlanning.statusVisited': 'Ziyaret edildi',
  'scout.dailyPlanning.statusPlanned': 'Planlandı',
  'scout.dailyPlanning.statusCompleted': 'Tamamlandı',
  'scout.createMission.title': 'Yeni görev oluştur',
  'scout.createMission.description': 'Ad, filtre ve atamaları seçin',
  'scout.createMission.nameLabel': 'Ad',
  'scout.createMission.nameRequired': 'Ad zorunludur',
  'scout.createMission.namePlaceholder': 'örn. Ankara Kuzey — Soğutma',
  'scout.createMission.nameAria': 'Görev adı',
  'scout.createMission.regionLabel': 'Bölge (isteğe bağlı)',
  'scout.createMission.regionPlaceholder': 'örn. Posta kodu 06xxx',
  'scout.createMission.regionAria': 'Bölge veya posta kodu',
  'scout.createMission.ownerLabel': 'Sahip',
  'scout.createMission.ownerPlaceholder': 'E-posta adresi',
  'scout.createMission.ownerAria': 'Sahip e-posta adresi',
  'scout.createMission.themeLabel': 'Tema (isteğe bağlı)',
  'scout.createMission.themePlaceholder': 'örn. Soğutma sistemleri',
  'scout.createMission.themeAria': 'Görev teması',
  'scout.createMission.productLabel': 'Ürün (isteğe bağlı)',
  'scout.createMission.productPlaceholder': 'örn. K-2000',
  'scout.createMission.productAria': 'Ürün',
  'scout.createMission.cancel': 'İptal',
  'scout.createMission.save': 'Kaydet',
  'scout.createMission.saveBusy': 'Kaydediliyor…',
  'scout.createMission.cancelAria': 'Görev oluşturmayı iptal et',
  'scout.createMission.saveAria': 'Görevi kaydet',
  'scout.createMission.saveBusyAria': 'Görev kaydediliyor',

  // Inventory

  // Sales

  // Purchase


  // Settings
  'settings.description': 'Uygulama ayarlarınızı ve özelleştirme seçeneklerini yönetin',
  'settings.typography.title': 'Tipografi',
  'settings.typography.description': 'Okunabilirlik veya daha fazla bilgi yoğunluğu için metin boyutu ve yoğunluğu ayarlayın',
  'settings.typography.scale.title': 'Metin boyutu',
  'settings.typography.scale.description': 'Standart ana tabana uygun; konfor uzun oturumlar için metni büyütür',
  'settings.typography.scale.ariaLabel': 'Metin boyutu ön ayarı',
  'settings.typography.scale.compact': 'Kompakt',
  'settings.typography.scale.standard': 'Standart',
  'settings.typography.scale.comfort': 'Konfor',
  'settings.tabs.appearance': 'Görünüm',
  'settings.tabs.account': 'Hesap',
  'settings.tabs.notifications': 'Bildirimler',
  'settings.tabs.security': 'Güvenlik',
  'settings.language.title': 'Dil ayarları',
  'settings.language.description': 'Arayüz için tercih ettiğiniz dili seçin',
  'settings.language.interfaceLanguage': 'Arayüz dili',
  'settings.language.interfaceLanguageDesc': 'Menüler, düğmeler ve arayüz öğeleri için dil seçin',
  'settings.theme.title': 'Renk şeması',
  'settings.theme.description': 'Arayüzünüzün görünümünü ve renklerini özelleştirin',
  'settings.theme.predefinedThemes': '10 önceden tanımlı temadan birini seçmek ister misiniz?',
  'settings.theme.goToThemeSettings': 'Tema ayarlarına git',
  'settings.themeSettings.title': 'Tema ayarları',
  'settings.themeSettings.description': 'Önceden tanımlı temalarla uygulamanızın görünümünü özelleştirin',
  'settings.themeSettings.themeDetails': 'Tema detayları',
  'settings.themeSettings.themeId': 'Tema ID:',
  'settings.themeSettings.colorScheme': 'Renk şeması:',
  'settings.account.profile.title': 'Profil bilgileri',
  'settings.account.profile.description': 'Kişisel bilgilerinizi ve hesap verilerinizi güncelleyin',
  'settings.account.profile.name': 'Ad',
  'settings.account.profile.email': 'E-posta',
  'settings.account.profile.role': 'Rol',
  'settings.account.profile.department': 'Departman',
  'settings.account.profile.editProfile': 'Profili düzenle',
  'settings.account.data.title': 'Veri yönetimi',
  'settings.account.data.description': 'Veri senkronizasyonu ve yedekleme ayarlarınızı yönetin',
  'settings.account.data.cloudSync': 'Bulut senkronizasyonu',
  'settings.account.data.cloudSyncEnabled': 'Ayarlarınız buluta senkronize ediliyor',
  'settings.account.data.cloudSyncDisabled': 'Bulut senkronizasyonu devre dışı (özellik bayrağı)',
  'settings.account.data.syncNow': 'Şimdi senkronize et',
  'settings.notifications.title': 'Bildirim ayarları',
  'settings.notifications.description': 'Bildirimleri nasıl alacağınızı yapılandırın',
  'settings.notifications.email.title': 'E-posta bildirimleri',
  'settings.notifications.email.description': 'E-posta ile bildirim alın',
  'settings.notifications.push.title': 'Anlık bildirimler',
  'settings.notifications.push.description': 'Tarayıcıda anlık bildirim alın',
  'settings.notifications.system.title': 'Sistem uyarıları',
  'settings.notifications.system.description': 'Önemli sistem bildirimleri',
  'settings.notifications.configure': 'Yapılandır',
  'settings.security.title': 'Güvenlik ayarları',
  'settings.security.description': 'Hesap güvenliğinizi ve gizlilik ayarlarınızı yönetin',
  'settings.security.password.title': 'Şifre',
  'settings.security.password.lastChanged': 'Son değişiklik 30 gün önce',
  'settings.security.password.change': 'Değiştir',
  'settings.security.twoFactor.title': 'İki faktörlü kimlik doğrulama',
  'settings.security.twoFactor.description': 'Ek güvenlik katmanı ekleyin',
  'settings.security.twoFactor.enable': 'Etkinleştir',
  'settings.security.sessions.title': 'Oturum yönetimi',
  'settings.security.sessions.description': 'Aktif oturumları yönetin',
  'settings.security.sessions.view': 'Oturumları görüntüle',
  'settings.company.title': 'Şirket ayarları',
  'settings.company.description': 'Şirket bilgilerinizi ve ayarlarınızı yönetin',
  'settings.company.edit': 'Şirketi düzenle',
  'settings.company.saveChanges': 'Değişiklikleri kaydet',
  'settings.company.cancel': 'İptal',
  'settings.company.tabs.general': 'Genel',
  'settings.company.tabs.contact': 'İletişim',
  'settings.company.tabs.billing': 'Faturalandırma',
  'settings.company.tabs.branding': 'Marka kimliği',
  'settings.company.general.companyInfo': 'Şirket bilgileri',
  'settings.company.general.companyName': 'Şirket adı',
  'settings.company.general.legalName': 'Yasal ad',
  'settings.company.general.taxId': 'Vergi numarası',
  'settings.company.general.registrationNumber': 'Kayıt numarası',
  'settings.company.general.industry': 'Sektör',
  'settings.company.general.foundedYear': 'Kuruluş yılı',
  'settings.company.general.employees': 'Çalışan sayısı',
  'settings.company.general.industry.technology': 'Teknoloji',
  'settings.company.general.industry.manufacturing': 'Üretim',
  'settings.company.general.industry.retail': 'Perakende',
  'settings.company.general.industry.healthcare': 'Sağlık',
  'settings.company.general.industry.finance': 'Finans',
  'settings.company.general.industry.other': 'Diğer',
  'settings.company.address.title': 'Adres bilgileri',
  'settings.company.address.street': 'Sokak adresi',
  'settings.company.address.city': 'Şehir',
  'settings.company.address.state': 'İl / Eyalet',
  'settings.company.address.zipCode': 'Posta kodu',
  'settings.company.address.country': 'Ülke',
  'settings.company.address.country.us': 'Amerika Birleşik Devletleri',
  'settings.company.address.country.ca': 'Kanada',
  'settings.company.address.country.uk': 'Birleşik Krallık',
  'settings.company.address.country.de': 'Almanya',
  'settings.company.address.country.fr': 'Fransa',
  'settings.company.address.country.other': 'Diğer',
  'settings.company.contact.title': 'İletişim bilgileri',
  'settings.company.contact.phone': 'Telefon',
  'settings.company.contact.email': 'E-posta adresi',
  'settings.company.contact.website': 'Web sitesi',
  'settings.company.contact.supportEmail': 'Destek e-postası',
  'settings.company.billing.title': 'Faturalandırma ayarları',
  'settings.company.billing.currency': 'Para birimi',
  'settings.company.billing.taxRate': 'Vergi oranı (%)',
  'settings.company.billing.paymentTerms': 'Ödeme koşulları',
  'settings.company.billing.billingCycle': 'Faturalandırma dönemi',
  'settings.company.billing.paymentTerms.net15': 'Net 15',
  'settings.company.billing.paymentTerms.net30': 'Net 30',
  'settings.company.billing.paymentTerms.net45': 'Net 45',
  'settings.company.billing.paymentTerms.net60': 'Net 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': 'Alındığında ödeme',
  'settings.company.billing.cycle.monthly': 'Aylık',
  'settings.company.billing.cycle.quarterly': 'Üç aylık',
  'settings.company.billing.cycle.annually': 'Yıllık',
  'settings.company.billing.cycle.custom': 'Özel',
  'settings.company.billing.summary.title': 'Faturalandırma özeti',
  'settings.company.billing.summary.currentPlan': 'Mevcut plan',
  'settings.company.billing.summary.monthlyCost': 'Aylık maliyet',
  'settings.company.billing.summary.nextBillingDate': 'Sonraki faturalandırma tarihi',
  'settings.company.billing.summary.paymentMethod': 'Ödeme yöntemi',
  'settings.company.billing.summary.status': 'Durum',
  'settings.company.billing.summary.active': 'Aktif',
  'settings.company.branding.title': 'Marka kimliği ve görünüm',
  'settings.company.branding.logo': 'Şirket logosu',
  'settings.company.branding.uploadLogo': 'Logo yükle',
  'settings.company.branding.logoHint': 'PNG, JPG en fazla 2MB',
  'settings.company.branding.favicon': 'Favicon',
  'settings.company.branding.uploadFavicon': 'Favicon yükle',
  'settings.company.branding.faviconHint': 'ICO, PNG en fazla 1MB',
  'settings.company.branding.primaryColor': 'Birincil renk',
  'settings.company.branding.secondaryColor': 'İkincil renk',
  'settings.usersRoles.stats.totalUsers': 'Toplam kullanıcı',
  'settings.usersRoles.stats.activeUsers': 'aktif kullanıcı',
  'settings.usersRoles.stats.totalRoles': 'Toplam rol',
  'settings.usersRoles.stats.roleConfigurations': 'Rol yapılandırmaları',
  'settings.userManagement.title': 'Kullanıcı yönetimi',
  'settings.userManagement.description': 'Kullanıcıları, rolleri ve sistem ayarlarını yönetin',
  'settings.userManagement.addUser': 'Kullanıcı ekle',
  'settings.userManagement.editUser': 'Kullanıcıyı düzenle',
  'settings.userManagement.createNewUser': 'Yeni kullanıcı oluştur',
  'settings.userManagement.updateUserInfo': 'Kullanıcı bilgilerini güncelle',
  'settings.userManagement.addNewUser': 'Sisteme yeni kullanıcı ekle',
  'settings.userManagement.tabs.users': 'Kullanıcılar',
  'settings.userManagement.tabs.appAccess': 'Uygulama erişimi',
  'settings.userManagement.tabs.roles': 'Roller',
  'settings.userManagement.toast.userCreated': 'Kullanıcı başarıyla oluşturuldu',
  'settings.userManagement.toast.userUpdated': 'Kullanıcı başarıyla güncellendi',
  'settings.userManagement.toast.userDeleted': 'Kullanıcı başarıyla silindi',
  'settings.userManagement.toast.roleCreated': 'Rol başarıyla oluşturuldu',
  'settings.userManagement.toast.roleUpdated': 'Rol başarıyla güncellendi',
  'settings.userManagement.toast.roleDeleted': 'Rol başarıyla silindi',
  'settings.userManagement.toast.error': 'Kullanıcı oluşturulamadı',
  'settings.userManagement.toast.errorUpdate': 'Kullanıcı güncellenemedi',
  'settings.userManagement.toast.errorDelete': 'Kullanıcı silinemedi',
  'settings.userManagement.toast.errorRoleCreate': 'Rol oluşturulamadı',
  'settings.userManagement.toast.errorRoleUpdate': 'Rol güncellenemedi',
  'settings.userManagement.toast.errorRoleDelete': 'Rol silinemedi',
  'settings.integrations.settings.security.enabled': 'Etkin',
  'settings.integrations.settings.security.disabled': 'Devre dışı',

  // Analytics - Pivot Table

  // Reports

  // Warehouse - Picking

  // Warehouse - Returns

  // Warehouse - ASN

  // CRM - Contacts
  'crm.contacts.title': 'CRM kişileri',
  'crm.contacts.description': 'Müşteri ve tedarikçi kişilerini adres bilgileriyle yönetin',
  'crm.contacts.add': 'Kişi ekle',
  'crm.contacts.edit': 'Kişiyi düzenle',
  'crm.contacts.delete': 'Kişiyi sil',
  'crm.contacts.view360': '360° görünüm',
  'crm.contacts.unassigned': 'Atanmamış',
  'crm.contacts.type.customer': 'Müşteri',
  'crm.contacts.type.supplier': 'Tedarikçi',
  'crm.contacts.type.partner': 'Partner',
  'crm.contacts.type.prospect': 'Aday',
  'crm.contacts.status.active': 'Aktif',
  'crm.contacts.status.inactive': 'Pasif',
  'crm.contacts.status.suspended': 'Askıya alındı',
  'crm.contacts.validation.companyRequired': 'Şirket adı zorunludur',
  'crm.contacts.validation.streetRequired': 'Sokak adresi zorunludur',
  'crm.contacts.validation.postalRequired': 'Posta kodu zorunludur',
  'crm.contacts.validation.cityRequired': 'Şehir zorunludur',
  'crm.contacts.validation.countryRequired': 'Ülke zorunludur',
  'crm.contacts.validation.nameRequired': 'Kişi adı zorunludur',
  'crm.contacts.validation.emailInvalid': 'Geçersiz e-posta adresi',
  'crm.contacts.validation.phoneRequired': 'Telefon zorunludur',
  'crm.contacts.validation.salesPersonRequired': 'Satış temsilcisi zorunludur',
  'crm.contacts.validation.ordererNameRequired': 'Sipariş veren adı zorunludur',
  'crm.contacts.validation.roleRequired': 'Rol zorunludur',
  'crm.contacts.validation.hoursRequired': 'Saat zorunludur',
  'crm.openMenu': 'Menüyü aç',

  // CRM - Leads
  'crm.leads.title': 'Potansiyel müşteriler',
  'crm.leads.description': 'Satış potansiyel müşterilerini yönetin ve dönüşümü takip edin',
  'crm.leads.add': 'Potansiyel müşteri ekle',
  'crm.leads.edit': 'Potansiyel müşteriyi düzenle',
  'crm.leads.delete': 'Potansiyel müşteriyi sil',
  'crm.leads.status.new': 'Yeni',
  'crm.leads.status.contacted': 'İletişime geçildi',
  'crm.leads.status.qualified': 'Nitelikli',
  'crm.leads.status.proposal': 'Teklif',
  'crm.leads.status.negotiation': 'Müzakere',
  'crm.leads.status.closedWon': 'Kazanıldı',
  'crm.leads.status.closedLost': 'Kaybedildi',
  'crm.leads.source.website': 'Web sitesi',
  'crm.leads.source.referral': 'Tavsiye',
  'crm.leads.source.email': 'E-posta',
  'crm.leads.source.phone': 'Telefon',
  'crm.leads.source.social': 'Sosyal medya',
  'crm.leads.source.other': 'Diğer',
  'crm.leads.value': 'Değer',
  'crm.leads.lastContact': 'Son iletişim',
  'crm.leads.notes': 'Notlar',
  'crm.leads.search': 'Potansiyel müşteri ara...',
  'crm.leads.filterByStatus': 'Duruma göre filtrele',
  'crm.leads.filterBySource': 'Kaynağa göre filtrele',
  'crm.leads.totalLeads': 'Toplam potansiyel müşteri',
  'crm.leads.pipelineValue': 'Pipeline değeri',
  'crm.leads.qualifiedLeads': 'Nitelikli potansiyel müşteriler',

  // Visit Report
  'visitReport.title': 'Ziyaret raporu',
  'visitReport.createTitle': 'Ziyaret raporu oluştur',
  'visitReport.titleFor': '{{name}} için ziyaret raporu',
  'visitReport.visitType': 'Ziyaret türü',
  'visitReport.coldVisit': 'Soğuk ziyaret',
  'visitReport.appointment': 'Randevu',
  'visitReport.salesOutcome': 'Satış sonucu',
  'visitReport.noContact': 'İletişim yok',
  'visitReport.conversation': 'Görüşme',
  'visitReport.demo': 'Demo',
  'visitReport.order': 'Sipariş',
  'visitReport.orderValue': 'Sipariş değeri (EUR)',
  'visitReport.nextStep': 'Sonraki adım',
  'visitReport.callback': 'Geri arama',
  'visitReport.sendOffer': 'Teklif gönder',
  'visitReport.revisit': 'Yeniden ziyaret',
  'visitReport.completed': 'Tamamlandı',
  'visitReport.appointmentWindow': 'Randevu penceresi (isteğe bağlı)',
  'visitReport.from': 'Başlangıç',
  'visitReport.to': 'Bitiş',
  'visitReport.contactName': 'Görüşülen kişi adı',
  'visitReport.enterName': 'Ad girin',
  'visitReport.roleFunction': 'Unvan / Rol',
  'visitReport.enterRole': 'Unvan girin',
  'visitReport.isDecisionMaker': 'Karar verici mi?',
  'visitReport.decisionMakerName': 'Karar verici adı',
  'visitReport.decisionMakerRole': 'Karar verici unvanı',
  'visitReport.email': 'E-posta (isteğe bağlı)',
  'visitReport.phone': 'Telefon (isteğe bağlı)',
  'visitReport.notes': 'Notlar (isteğe bağlı)',
  'visitReport.additionalInfo': 'Ek bilgiler...',
  'visitReport.productsDiscussed': 'Ürünler tartışıldı mı?',
  'visitReport.annualDemand': 'Yıllık talep',
  'visitReport.select': 'Seçin',
  'visitReport.interest': 'İlgi',
  'visitReport.interestHigh': 'yüksek',
  'visitReport.interestMedium': 'orta',
  'visitReport.interestLow': 'düşük',
  'visitReport.modelFeedback': 'Sistem önerisi uygun muydu?',
  'visitReport.feedbackYes': 'Evet',
  'visitReport.feedbackPartially': 'Kısmen',
  'visitReport.feedbackNo': 'Hayır',
  'visitReport.feedbackNotSeen': 'Görülmedi',
  'visitReport.branchCorrect': 'Sektör doğru mu? (isteğe bağlı)',
  'visitReport.selectBranch': 'Sektör seçin',
  'visitReport.branchConstruction': 'İnşaat',
  'visitReport.branchIndustry': 'Sanayi',
  'visitReport.branchTrade': 'Ticaret',
  'visitReport.branchService': 'Hizmet',
  'visitReport.noInterestReason': 'İlgi yok nedeni',
  'visitReport.wrongProduct': 'Yanlış ürün',
  'visitReport.wrongTiming': 'Zamanlama uygun değil',
  'visitReport.existingSupplier': 'Mevcut tedarikçi',
  'visitReport.noBudget': 'Bütçe yok',
  'visitReport.noNeed': 'İhtiyaç yok',
  'visitReport.decisionMakerNotReached': 'Karar vericiye ulaşılamadı',
  'visitReport.additionalRemarks': 'Ek notlar (isteğe bağlı)',
  'visitReport.error': 'Hata',
  'visitReport.validationError': 'Lütfen ziyaret türü ve satış sonucu seçin.',
  'visitReport.deferralNotPossible': 'Erteleme mümkün değil',
  'visitReport.maxDeferralReached': 'Son raporu zaten ertelediniz. Lütfen doldurun.',
  'visitReport.reportDeferred': 'Rapor ertelendi',
  'visitReport.deferralMessage': 'Raporu daha sonra doldurabilirsiniz.',
  'visitReport.reportCreated': 'Ziyaret raporu oluşturuldu',
  'visitReport.reportSaved': 'Ziyaret raporu kaydedildi.',
  'visitReport.reportSavedFor': '{{name}} için ziyaret raporu kaydedildi.',
  'visitReport.reportError': 'Ziyaret raporu oluşturulamadı.',
  'visitReport.stepOf': 'Adım {{current}} / {{total}}',
  'visitReport.back': 'Geri',
  'visitReport.cancel': 'İptal',
  'visitReport.inAHurry': 'Acelem var',
  'visitReport.next': 'İleri',
  'visitReport.saving': 'Kaydediliyor...',
  'visitReport.finishVisit': 'Ziyareti tamamla',
  'visitReport.contactNotes': 'Görüşülen kişi hakkında ek bilgiler...',
  'visitReport.callingQueue.prompt': 'Bu potansiyel müşteri için yapay zeka randevu araması hazırlansın mı?',
  'visitReport.callingQueue.yes': 'Evet, kuyruğa al',
  'visitReport.callingQueue.no': 'Hayır',
  'visitReport.callingQueue.toast': 'Potansiyel müşteri arama kuyruğuna alındı.',

  // Admin (SS-145)

  // Learning (SS-145)
  'learning.lessonViewer.audioNotSupported': 'Tarayıcınız ses öğesini desteklemiyor.',
  'learning.lessonViewer.complete': 'Tamamla',
  'learning.lessonViewer.formatNotSupported': 'Format desteklenmiyor',
  'learning.lessonViewer.videoNotSupported': 'Tarayıcınız video öğesini desteklemiyor.',
  'learning.moduleEditor.pillar': 'Sütun',
  'learning.moduleEditor.pillarLabel': 'Sütun',
  'learning.tabs.availableLessons': 'Mevcut dersler',
  'learning.tabs.availableQuizzes': 'Mevcut quizler',
  'learning.lehrplan.title': 'Müfredat',
  'learning.lehrplan.subtitle': 'Müfredat ve öğrenme hedeflerini yönetin',
  'learning.curriculumPlanning.title': 'Müfredat planlama',
  'learning.curriculumPlanning.subtitle': 'Müfredatı yapılandırın ve öğrenme içeriklerini atayın',

  // Modals
  'modals.assignMissionModal.close': 'Kapat',
  'modals.assignMissionModal.searchPlaceholder': 'Ara (başlık/sektör)',
  'modals.assignMissionModal.searchAriaLabel': 'Ara',
  'modals.missionQuickViewModal.description': 'Görev hızlı özeti. Detaylar için görev sayfasını açın.',
  'modals.missionQuickViewModal.close': 'Kapat',
  'modals.missionQuickViewModal.openDetails': 'Detayları aç',
  'modals.missionQuickViewModal.openDetailsAria': 'Görev detayını aç',
  'modals.leadDetailModal.close': 'Kapat',
  'modals.leadDetailModal.whoIsThis': 'Bu kim?',
  'modals.leadDetailModal.whatDoTheyNeed': 'Neye ihtiyaçları var?',
  'modals.leadDetailModal.whatDoISay': 'Ne söylemeliyim?',
  'modals.leadDetailModal.moreProducts': 'Diğer ürünler',
  'modals.regionDetailsModal.description': 'Görev detayları özeti. Bu görünüm salt okunurdur.',
  'modals.regionDetailsModal.edit': 'Düzenle',
  'modals.regionDetailsModal.close': 'Kapat',
  'modals.editRegionModal.close': 'Kapat',
  'modals.editRegionModal.description': 'Görev için saat ve notu düzenleyin. Durum salt okunurdur.',
  'modals.editRegionModal.statusReadonlySrOnly': 'Durum salt okunurdur.',
  'modals.splitAssignmentDialog.actionLabel': 'İşlem seçin',
  'modals.splitAssignmentDialog.confirmButton': 'Onayla',
  'modals.addAppointmentModal.companyAriaLabel': 'Şirket / potansiyel müşteri seçin veya girin',
  'modals.addAppointmentModal.commitmentConfirmed': 'Onaylandı',
  'modals.rejectLead.title': 'Potansiyel müşteriyi reddet',
  'modals.rejectLead.closeAria': 'İletişimi kapat',
  'modals.rejectLead.description': 'En az bir red nedeni seçin.',
  'modals.rejectLead.reasonsLabel': 'Red nedenleri',
  'modals.rejectLead.reasonsError': 'Lütfen en az bir neden seçin.',
  'modals.rejectLead.otherReasonLabel': 'Diğer neden',
  'modals.rejectLead.otherReasonPlaceholder': 'Lütfen nedeni açıklayın...',
  'modals.rejectLead.otherReasonAria': 'Diğer red nedeni',
  'modals.rejectLead.otherReasonError': 'Lütfen bir neden girin.',
  'modals.rejectLead.cancel': 'İptal',
  'modals.rejectLead.confirm': 'Reddet ({count})',
  'modals.rejectLead.reason.outOfBusiness': 'Artık aktif değil',
  'modals.rejectLead.reason.temporarilyClosed': 'Geçici olarak kapalı',
  'modals.rejectLead.reason.knownAndUnsuitable': 'Bilinen ve uygun değil',
  'modals.rejectLead.reason.noInterest': 'İlgi yok',
  'modals.rejectLead.reason.wrongContact': 'Yanlış kişi',
  'modals.rejectLead.reason.other': 'Diğer',

  // UI / App components
  'app.routes.loadingSettings': 'Ayarlar yükleniyor...',
  'companySearch.filters.companySize': 'Şirket büyüklüğü',
  'curriculum.modules.pillar': 'Sütun',
  'curriculum.modules.selectLevel': 'Seviye seçin',
  'curriculum.modules.selectPillar': 'Sütun seçin',
  'curriculum.modules.selectPillarOption': 'Sütun seçin',
  'missions.management.demoPerformed': 'Demo yapıldı',
  'missions.management.demoPerformedLabel': 'Demo yapıldı',
  'missions.management.kpiDescription': 'Karar verici görüşüldü, demo yapıldı, gelir',
  'missions.management.moreActions': 'Görev için diğer işlemleri göster',
  'missions.management.publish': 'Yayınla',
  'missions.management.searchPlaceholder': 'Ara (ad/bölge/tema/ürün)',
  'mobile.layout.closeMenu': 'Menüyü kapat',
  'mobile.layout.menu': 'Menü',
  'mobile.layout.noOfflineContent': 'Çevrimdışı içerik yok',
  'mobile.layout.offlinePerformance': 'Daha iyi performans için çevrimdışı',
  'navigation.appOverview': 'Uygulama özeti',
  'navigation.tileCard.openActions': 'Kutu için işlemleri aç',
  'scout.preferences.badenWuerttemberg': 'Baden-Württemberg',
  'scout.preferences.thueringen': 'Türingiya',
  'scout.sprints.ciEstimate': 'CI süre tahmini',
  'scout.sprints.estimatedMinutes': 'Tahmini dakika',
  'scout.help.selectArticle': 'Sol taraftan bir makale seçin veya yardım makalesi açmak için arama kullanın.',
  'styleGuide.charts.noStatusColors': 'Grafikler durum renkleri kullanmamalı',
  'styleGuide.confirmation': 'Onay',
  'styleGuide.description': 'Açıklama',
  'styleGuide.statusSemantics.success': 'Başarı = Tamamlandı / Tamam',
  'tickets.list.filterPriority': 'Önceliğe göre filtrele',
  'ui.calendar.nextMonth': 'Sonraki ay',
  'ui.errorBoundary.returnToDashboard': 'Panele dön',
  'ui.impersonation.selectImpersonation': 'Kimliğe bürünme seçin',
  'ui.impersonation.selectUser': 'Kullanıcı seçin:',
  'ui.routingPreview.openAppleMaps': 'Apple Maps\'te aç',
  'ui.routingPreview.openGoogleMaps': 'Google Maps\'te aç',
  'ui.routingPreview.stopsLabel': '{{count}} durak · {{distance}} km · {{time}} dk (tahmini)',
  'ui.routingPreview.title': 'Rota önizlemesi',
  'weeklyPlanning.appointmentModal.additionalNotes': 'Ek notlar',
  'weeklyPlanning.legacyAppointments.addAppointment': 'Randevu ekle',

  // Visit Report — Rejection / Compliance
  'scout.visitReport.compliance.title': 'Açık ziyaret raporları',
  'scout.visitReport.compliance.description': '{{count}} açık ziyaret raporunuz var. Lütfen önce bunları doldurun.',
  'scout.visitReport.compliance.lockoutTitle': 'Raporlar gerekli',
  'scout.visitReport.compliance.lockoutDescription': 'Devam etmeden önce lütfen tüm açık raporları doldurun.',
  'scout.visitReport.compliance.deferButton': 'Daha sonra doldur',
  'scout.visitReport.compliance.deferCount': '{{remaining}} erteleme kaldı',
  'scout.visitReport.compliance.noDeferrals': 'Erteleme kalmadı',
  'scout.visitReport.compliance.fillReport': 'Raporu doldur',
  'scout.visitReport.compliance.morningLockout': 'Tüm açık raporlar doldurulana kadar günlük planlama kilitli.',

  // PO Sprints, Purchase, Sales, Common
  'common.next': 'İleri',

  // Scout Wochenplanung aggregates

  // Scout Mission Control — Plan View

  // CRM Leads (flat keys)
  'crm.leads': 'Potansiyel müşteriler',
  'crm.closedWon': 'Kazanılan kapanışlar',
  'crm.searchPlaceholder': 'Potansiyel müşteri ara...',
  'crm.name': 'Ad',
  'crm.company': 'Şirket',
  'crm.contact': 'İletişim',
  'crm.source': 'Kaynak',
  'crm.value': 'Değer',
  'crm.lastContact': 'Son iletişim',
  'crm.viewDetails': 'Detayları göster',
  'crm.editLead': 'Potansiyel müşteriyi düzenle',
  'crm.addNote': 'Not ekle',
  'crm.convertToCustomer': 'Müşteriye dönüştür',
  'crm.deleteLead': 'Potansiyel müşteriyi sil',
  'crm.leadDetails': 'Potansiyel müşteri detayları',
  'crm.addNewLead': 'Yeni potansiyel müşteri ekle',
  'crm.viewLeadDetails': 'Potansiyel müşteri detaylarını göster',
  'crm.createNewLead': 'Yeni potansiyel müşteri oluştur',
  'crm.fullName': 'Tam ad',
  'crm.email': 'E-posta',
  'crm.phone': 'Telefon',
  'crm.estimatedValue': 'Tahmini değer',
  'crm.notes': 'Notlar',
  'crm.status.new': 'Yeni',
  'crm.status.contacted': 'İletişime geçildi',
  'crm.status.qualified': 'Nitelikli',
  'crm.status.proposal': 'Teklif',
  'crm.status.negotiation': 'Müzakere',
  'crm.status.closedWon': 'Kazanıldı',
  'crm.status.closedLost': 'Kaybedildi',
  'crm.source.website': 'Web sitesi',
  'crm.source.referral': 'Tavsiye',
  'crm.source.tradeShow': 'Fuar',
  'crm.source.coldCall': 'Soğuk arama',
  'crm.source.socialMedia': 'Sosyal medya',
  'crm.source.emailCampaign': 'E-posta kampanyası',

  // Supplier onboarding form
  'country.US': 'Amerika Birleşik Devletleri',
  'country.CA': 'Kanada',
  'country.MX': 'Meksika',
  'country.GB': 'Birleşik Krallık',
  'country.DE': 'Almanya',
  'country.FR': 'Fransa',
  'country.other': 'Diğer',

  // Missing keys (added from en/de)
  'common.saving': 'Kaydediliyor…',
  'common.archive': 'Arşivle',
  'scout.missions.industries.placeholder': 'Sektör seçin',
  'scout.missions.industries.search': 'Sektör ara...',
  'scout.missions.industries.empty': 'Sektör bulunamadı',
  'scout.missions.products.placeholder': 'Ürün aileleri seçin',
  'scout.missions.products.search': 'Ürün aileleri ara...',
  'scout.missions.products.empty': 'Ürün ailesi bulunamadı',
  'scout.search.selectStatus': 'Durum seçin...',
  'scout.dailyPlanning.jokerAdd': 'Joker kullan',
  'scout.dailyPlanning.jokerTitle': 'Joker durak',
  'scout.dailyPlanning.jokerUsed': 'kullanıldı',
  'scout.dailyPlanning.jokerLimitReached': 'Günlük joker durağı limitine ulaşıldı.',
  'scout.dailyPlanning.jokerCompany': 'Şirket',
  'scout.dailyPlanning.jokerCompanyPlaceholder': 'Şirket adı girin',
  'scout.dailyPlanning.jokerReason': 'Gerekçe',
  'scout.dailyPlanning.jokerReasonPlaceholder': 'Bu durak neden gerekli?',
  'scout.dailyPlanning.jokerCancel': 'İptal',
  'scout.dailyPlanning.jokerSubmit': 'Joker kullan',
  'scout.dailyPlanning.jokerCreateError': 'Joker durağı oluşturulamadı.',
  'missions.management.decisionMakerMet': 'Karar verici ile görüşüldü',
  'missions.management.wonAmount': 'Kazanılan tutar',
  'common.active': 'Aktif',
  'common.archived': 'Arşivlendi',
  'common.planned': 'Planlandı',
  'missionControl.totalLeads': 'Toplam Potansiyel Müşteri',
  'missionControl.completedLeads': 'Tamamlanan Potansiyel Müşteriler',

  'survey.contact.name': 'Ad',
  'survey.contact.namePlaceholder': 'Ad girin',
  'survey.contact.function': 'Görev / Rol',
  'survey.contact.functionPlaceholder': 'Görev girin',
  'survey.contact.email': 'E-posta',
  'survey.contact.emailPlaceholder': 'E-posta adresi girin',
  'survey.contact.phone': 'Telefon',
  'survey.contact.phonePlaceholder': 'Telefon numarası girin',
  'survey.contact.isDecisionMaker': 'Karar verici mi?',

  'atc.registry.detailV2.embodiments.live': 'Live',
  'atc.registry.detailV2.embodiments.retired': 'Retired',
}
